module.exports = (__webpack_public_path__ || '') + "static/images/apple-touch-icon-152x152-3bd09034bd5327843c9eab1a35205e44.png";